module.exports = __webpack_public_path__ + "img/img3.692a73ac.jpg";